import { atomWithStorage, createJSONStorage } from 'jotai/utils';

export const LOCATIONS_DASHBOARD_BANNER_STORAGE_KEY =
  'v1-locations-dashboard-banner-dismissal';

export const LOCATIONS_DASHBOARD_BANNER_VERSION = '2026-08-locations-banner-v1';

export type LocationsBannerDismissals = Record<string, string[]>;

const locationsBannerStorage = createJSONStorage<LocationsBannerDismissals>(() => localStorage);

export const locationsDashboardBannerDismissalsAtom = atomWithStorage<LocationsBannerDismissals>(
  LOCATIONS_DASHBOARD_BANNER_STORAGE_KEY,
  {},
  locationsBannerStorage,
  { getOnInit: true },
);
